import React from 'react';

import {BenchlingNodeV2} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNode';
import {
  SectionsSummary,
  SectionsSummaryProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeSummary';
import {BenchlingNodeV2Status} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeV2Constants';
import {
  StandardHeader,
  StandardHeaderProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardHeader';
import {
  StandardSections,
  StandardSectionsProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSections';

export interface StandardNodeProps {
  /** Whether the node should be disabled */
  isDisabled?: boolean;
  /** The current status of the node */
  status?: BenchlingNodeV2Status;
  /** A {@link StandardHeaderProps}. If not provided, no header will be rendered. */
  headerProps?: StandardHeaderProps;
  /** A {@link StandardSectionsProps}. If not provided, no sections will be rendered. */
  sectionsProps?: StandardSectionsProps;
  /** A {@link SectionsSummaryProps}. If not provided, no sections summary will be rendered. */
  sectionsSummaryProps?: SectionsSummaryProps;
}

/**
 * A standard flowchart node.
 * @package
 */
export function StandardNode(props: StandardNodeProps): JSX.Element {
  const {isDisabled, headerProps, sectionsProps, sectionsSummaryProps, status} = props;
  return (
    <BenchlingNodeV2 isDisabled={isDisabled} status={status}>
      {headerProps != null && <StandardHeader {...headerProps} />}
      {sectionsSummaryProps != null && <SectionsSummary {...sectionsSummaryProps} />}
      {sectionsProps != null && <StandardSections {...sectionsProps} />}
    </BenchlingNodeV2>
  );
}
